<template>
  <div class="container bottom-fix-padding">

    <div style="display:none">
      <form name="payFormCcard" id="ccform" method="post" action="https://www.paydollar.com/b2c2/eng/dPayment/payComp.jsp">
      <!-- <form name="payFormCcard" id="ccform" method="post" action="https://test.paydollar.com/b2cDemo/eng/dPayment/payComp.jsp"> -->
        <tr>
          <td align="center" colspan="2">Required Parameter ( with UTF-8 Encoding ) for connect to our payment page</td>
        </tr>
        <tr>
          <td align="right">merchantId:</td>
          <td align="left"><input type="text" name="merchantId" v-model="form.merchantId"> </td>
        </tr>
        <tr>
          <td align="right">amount:</td>
          <td align="left"><input type="text" name="amount" v-model="form.amount"> </td>
        </tr>
        <tr>
          <td align="right">orderRef:</td>
          <td align="left"><input type="text" name="orderRef" v-model="form.orderRef" > </td>
        </tr>
        <tr>
          <td align="right">currCode:</td>
          <td align="left"><input type="text" name="currCode" v-model="form.currCode" > </td>
        </tr>
        <tr>
          <td align="right">successUrl:</td>
          <td align="left"><input type="text" name="successUrl" v-model="successUrl"> </td>
        </tr>
        <tr>
          <td align="right">failUrl:</td>
          <td align="left"><input type="text" name="failUrl" v-model="failUrl"> </td>
        </tr>
        <tr>
          <td align="right">errorUrl:</td>
          <td align="left"><input type="text" name="errorUrl" v-model="errorUrl"> </td>
        </tr>
        <tr>
          <td align="right">payType:</td>
          <td align="left"><input type="text" name="payType"  v-model="form.payType" > </td>
        </tr>
        <tr>
          <td align="right">lang:</td>
          <td align="left"><input type="text" name="lang" v-model="form.lang"> </td>
        </tr>

        <tr>
          <td align="right">Card Type</td>
          <td>
            <input type="radio" name="pMethod" value="UPOP" checked="true">VISA
          </td>
        </tr>
        <tr>
          <td align="right"> Card Number </td>
          <td align="left"><input name="cardNo" type="text" v-model="cc.digit" maxlength="16"></td>
        </tr>
        <tr>
          <td align="right"> Card Verification Number </td>
          <td align="left"><input name="securityCode" type="text" v-model="cc.cvv" value="" maxlength="4"></td>
        </tr>
        <tr>
          <td align="right"> Expiry Date</td>
          <td align="left">
            <select name="epMonth" v-model="cc.validmm">
              <option value="">--</option>
              <option value="01">01</option>
              <option value="02">02</option>
              <option value="03">03</option>
              <option value="04">04</option>
              <option value="05">05</option>
              <option value="06">06</option>
              <option value="07">07</option>
              <option value="08">08</option>
              <option value="09">09</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
            /
            <select name="epYear">
              <option v-model="cc.validyy" selected>{{cc.validyy}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td align="right"> Holder Name </td>
          <td align="left"><input name="cardHolder" type="text" v-model="cc.name"></td>
        </tr>

        <tr>
          <td align="center" colspan="2">Optional Parameter for connect to our payment page</td>
        </tr>
        <tr>
          <td align="right">secureHash:</td>
          <td align="left"><input type="text" name="secureHash" v-model="form.secureHash" > </td>
        </tr>
        <tr>
          <td align="right">remark:</td>
          <td align="left"><input type="text" name="remark" v-model="form.remark"> </td>
        </tr>

      </form>
    </div>
    <div id="loadingToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
            <i class="weui-loading weui-icon_toast"></i>
            <p class="weui-toast__content">正在跳转..</p>
        </div>
    </div>
  </div>
</template>

<script>
import creditCardType, { getTypeInfo, types as CardType } from 'credit-card-type';
import qs from 'qs'

export default {
  name: 'HelloWorld',
  data () {
    return {
      isSending:false,
      cvvShow:false,
      localError:[],
      localErrorShow:false,
      cc:{
        'name':'',
        'digit':'',
        'validmm':'',
        'validyy':'',
        'cvv':'',
      },
      form:{
        merchantId:"",
        orderRef:"",
        currCode:"",
        amount: "",
        payType: "",
        lang: "",
        remark: "",
        order_number: "",
        pay_status: "",
        secureHash: ""
      }
    }
  },
  created: function () {
    document.querySelector("html").classList.add("grey-background");
    this.pay();
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    checkSubmit(){
        return true;
    },
    pay(){
      if(this.isSending){
        return false;
      }
      else{
        if(this.checkSubmit()){
          let payObject={};
          let that = this;
          this.isSending = true;
          payObject.pay_type = 4;
          payObject.order_number = this.$route.query.id;
          this.axios.post(this.apiURL()+'/Payment_Order/paymentAmount', qs.stringify(payObject))
          .then(function (response) {
            if(response.data.error_code==0){
              that.form = response.data.data;
              that.sleep(500).then(() => {
                document.querySelector("#ccform").submit();
              });
            }
            else{
              console.log(response)
              alert("支付失败："+response.data.data)
              that.isSending=false;
              that.$router.push('/order-prepay?id='+that.$route.query.id)
            }
          })
          .catch(function (error) {
              alert("支付失败，请检查网络并重新尝试")
              that.isSending=false;
              that.$router.push('/order-prepay?id='+that.$route.query.id)
          });
        }
      }
    },
  },
  computed:{
    successUrl: function () {
      let url = this.theURL()+"/order-success?id="+this.$route.query.id+"&pay_status="+this.form.pay_status;
      return url;
    },
    failUrl: function () {
      let url = this.theURL()+"/order-error-cc?id="+this.$route.query.id;
      return url;
    },
    errorUrl: function () {
      let url = this.theURL()+"/order-error-cc?id="+this.$route.query.id;
      return url;
    },
  },
  watch: {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.navi{
  color:#fff;
}
.top-bg{
  background-image: url('/static/img/order/payment-bg.svg');
  background-repeat: no-repeat;
  width:100%;
  height:120px;
  background-position: center center;
  background-size: cover;
  position:absolute;
  top:0;
  padding-top:15px;
}
.container{
  background-color: #f8f8f8;
  padding-bottom:60px;
}
.weui-cells__title{
    font-size: 22pt;
    text-align: center;
    padding: 0 0 2vh 0;
    font-weight: bold;
}
.title{
  color:#fff;
}

.addr-title{
    font-size:0.6em;
    line-height:2em;
    color:#444;
    vertical-align:top;
    display:inline-block;
    text-align:center;
}

.container /deep/ .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
  color: #fe9567;
}

.deleteWP{
    padding:18px;
}

.parking-icon{
    color:#fe9567;
    line-height:1.5;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.padding-fix{
    padding-right:13px;
}

.placeholder-color{
    color:#777;
}
.cvv-tutorial{
  margin-top:14px;
  text-align:center;
  img{
    width:60%;
  }
  .cvv-text{
    font-size:0.9em;
  }
}
.cc-visa{
  height:14px;
}
.cc-master{
  height:24px;
}
.cc-all{
  height:24px;
}
.icon-error{
  font-size:18px;
}
.icon-help-circle{
  font-size:18px;
}
.main{
  margin-top:50px;
}
.ssl{
  width:60px;
  margin:0 10px;
}

.cc-line{
  color:#999;
}

.valign{
  display: flex;
	justify-content:space-between;
	align-items:center
}
.ssl-text{
  font-size:0.7em;
  color:#888;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order-upop.vue